import bg from './locale/bg.json';
import en from './locale/en.json';
import es from './locale/es.json';
import pl from './locale/pl.json';
import ru from './locale/ru.json';
import kk from './locale/kk.json';

export default {
  bg,
  en,
  es,
  kk,
  pl,
  ru,
};
